import React, { FunctionComponent } from "react";

const CommentBoxIcon: FunctionComponent = () => {
  // https://www.streamlinehq.com/icons/streamline-regular/messages-chat-smileys/messages-speech-bubbles/comment-box
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="-0.25 -0.25 24.5 24.5">
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="M21.75 18.75H11.25L5.25 23.25V18.75H2.25C1.45 18.75 0.75 18.05 0.75 17.25V2.25C0.75 1.45 1.45 0.75 2.25 0.75H21.75C22.55 0.75 23.25 1.45 23.25 2.25V17.25C23.25 18.05 22.55 18.75 21.75 18.75Z"
      ></path>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="M4.15002 12.25H11.65"
      ></path>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="M14.45 12.25H19.75"
      ></path>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="M4.15002 15.3499H9.45003"
      ></path>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="M17.15 15.3499H19.75"
      ></path>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="M12.05 15.3499H14.75"
      ></path>
    </svg>
  );
};

export default CommentBoxIcon;
